<template>
    <div class="bg-white shadow-lines sm:shadow-dreamy relative" style="height: 630px; overflow: hidden;">
        <div class="py-8 px-8">
            <div><img :src="form.image.url" class="w-full"></div>
            <div class="text-sm text-black text-center mt-4">
                <template v-if="product.type === 'memorial_card'">Till minne av</template>
            </div>
            <div class="text-xl text-blue-400 text-center mt-4 h-8 font-bold">{{ form.subject }}</div>
            <div class="text-black font-sans mt-1 text-center" ref="greeting" style="font-size: 0.65rem">
                <span v-html="greeting"></span>
            </div>
            
            <div class="absolute" style="bottom: 15px; left: 32px; right: 32px">
                <div class="border-t border-black w-full mb-2"></div>
                <div class="flex items-center">
                    <div class="mr-8"><img src="/images/card-footer-logo.jpg" alt=""></div>
                    <div style="font-size: 6px">
                        Barndiabetesfonden stödjer forskning som syftar till att förebygga, lindra och bota typ 1 diabetes hos barn, ungdomar och vuxna.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CardPreview",
        props: {
            form: {},
            product: {},
        },
        computed: {
            greeting: function() {
                return this.form.greeting.replace(/(?:\r\n|\r|\n)/g, '<br>');
            }
        },
        watch: {
            'form.greeting': function() {
                this.checkGreetingHeight()
            }
        },
        data() {
            return {
            }
        },
        methods: {
            checkGreetingHeight() {
                if (this.$refs.greeting.clientHeight > 225) {
                    this.$emit('validation', {
                        passes: false,
                        message: 'Texten är för lång',
                    })

                    return
                }

                this.$emit('validation', {
                    passes: true,
                })
            }
        }
    }
</script>